export default "__VITE_ASSET__FKu8UyYp__"